
import React, { lazy, Suspense, useState, useEffect } from 'react';
import { Button, Select, Card, Loader } from '@scuf/common';
import i18next from '../../i18next';
import './TitanLoginPage.scss';
import authService from '../../authService';
import { ReactComponent as ForgeLogo } from '../../assets/honeywell-forge.svg';
import { ReactComponent as IntegratorAvatar } from '../../assets/user-avatar-1.svg';
import { ReactComponent as CustomerAvatar } from '../../assets/user-avatar-2.svg';
import { useQuery } from '../../customHooks/useQuery';
import { URLSource } from '../../models';
const AppFooter = lazy(() => import(/* webpackPreload: true */ /* webpackChunkName: "initial" */ '../../components/Footer/Footer'));

const environmentVariables = (window as any).ENV;

const hstName = window.location.href;

const regionOptions = [
  { value: 'ae', text: 'AE Region' },
  { value: 'eu', text: 'EU Region' },
  { value: 'us', text: 'US Region' }
];

const TitanLoginPage = () => {
  const searchParams = useQuery();
  const source = searchParams.get('source');
  const prompt = searchParams.get('prompt') || undefined;

  const [dataCentre, setdataCentre] = useState<string>('');
  const [isRedirecting, setIsRedirecting] = useState<boolean>(true);

  const handleChange = (value: string) => {
    setdataCentre(value);
    localStorage.setItem('selectedDataCentre', value);
  };

  useEffect(() => {
    const storedValue = localStorage.getItem('selectedDataCentre');
    const dataCenter = storedValue ? storedValue : '';

    if ((source ?? '').toLocaleLowerCase() === URLSource.Titan) {
      localStorage.setItem('selectedLoginOption', 'SSO');
      authService.login().catch(() => {
        setIsRedirecting(false);
      });
    } else {
      authService.getUser().then(user => {
        if (user) {
          setdataCentre(dataCenter);
          if (dataCenter.length === 0) {
            setLocalDataCenter();
          }
          if (dataCentre === 'ae') {
            (window as any).location = `${environmentVariables.BASE_URL_AE}/app/feature/home`;
          } else if (dataCentre === 'eu') {
            (window as any).location = `${environmentVariables.BASE_URL_EU}/app/feature/home`;
          } else {
            (window as any).location = `${environmentVariables.BASE_URL_US}/app/feature/home`;
          }
        } else {
          setdataCentre(dataCenter);
          setLocalDataCenter();
          setIsRedirecting(false);
        }
      }).catch(() => {
        setIsRedirecting(false);
      });
    }
  }, [source]);

  const redirectRegionURL = (isSSOLogin: boolean) => {
    localStorage.setItem('selectedDataCentre', dataCentre);
    localStorage.setItem('selectedLoginOption', isSSOLogin ? 'SSO' : 'FORGE');
    authService.getUser().then(user => {
      if (user) {
        if (dataCentre === 'ae') {
          (window as any).location = `${environmentVariables.BASE_URL_AE}/app/feature/home`;
        } else if (dataCentre === 'eu') {
          (window as any).location = `${environmentVariables.BASE_URL_EU}/app/feature/home`;
        } else {
          (window as any).location = `${environmentVariables.BASE_URL_US}/app/feature/home`;
        }
      } else {
        authService.login(prompt);
      }
    });
  };

  const setLocalDataCenter = () => {
    if (hstName.includes((window as any).ENV.ADMIN_AE_HOSTNAME)) {
      setdataCentre((window as any).ENV.ADMIN_AE_HOSTNAME);
    }
    else if (hstName.includes((window as any).ENV.ADMIN_EU_HOSTNAME)) {
      setdataCentre((window as any).ENV.ADMIN_EU_HOSTNAME);
    }
    else {
      setdataCentre('us');
    }
  };


  if (isRedirecting) {
    return <Loader />;
  }

  return (
    <>
      <div className='welcome-screen'>
        <div className='welcome-screen-content'>
          <div className='welcome-screen-content-logo'>
            <ForgeLogo className='welcome-screen-logo' />
          </div>
          <div className='welcome-screen-content-selection-note'>{i18next.t('loginWelcomeNote')}</div>
          <div className='welcome-screen-content-role-selection'>
            <Card className='welcome-screen-content-role-selection-card'>
              <IntegratorAvatar className='welcome-screen-content-role-selection-card-avatar' />
              <div className='welcome-screen-content-role-selection-card-role-note'>{i18next.t('loginUserIntegratorRole')}</div>
              <Button
                className='login-button'
                size='medium'
                onClick={() => redirectRegionURL(true)}
              >
                {i18next.t('landingLogin')}
              </Button>
            </Card>
            <Card className='welcome-screen-content-role-selection-card'>
              <CustomerAvatar className='welcome-screen-content-role-selection-card-avatar' />
              <div className='welcome-screen-content-role-selection-card-role-note'>{i18next.t('loginUserCustomerRole')}</div>
              <Button
                className='login-button'
                size='medium'
                onClick={() => redirectRegionURL(false)}
              >
                {i18next.t('landingLogin')}
              </Button>
            </Card>
          </div>
          {/* <div className='welcome-screen-content-region-selection'>
            <div className='welcome-screen-content-region-selection-label'>{i18next.t('dataCentre')}</div>
            <Select
              className='welcome-screen-content-region-selection-select'
              options={regionOptions}
              value={dataCentre}
              onChange={(value) => handleChange(value)}
            />
          </div> */}
        </div>
      </div>
      <Suspense fallback={null}>
        <AppFooter />
      </Suspense>
    </>
  );
}

export default TitanLoginPage;